import StatusBadge from "../components/StatusBadge";

function LeagueRulesPage({
  title = "League Rules",
  description = "Review the public rulebook, tiebreak policy, and match settings for the selected competition.",
  metricsNode = null,
  gateNode = null,
  message = "",
  error = "",
  tabsNode = null,
  railNode = null,
  mainNode = null,
  selectedLeague = null,
}) {
  return (
    <section className="appRoutePage leagueRulesRoutePage">
      <div className="routePageHeader leaguePageHeader">
        <div className="leaguePageHero">
          <div className="leaguePageHeroMark" aria-hidden="true">{"\u2696"}</div>
          <div className="leaguePageHeroCopy">
            <span className="leaguePageEyebrow">Competition Rulebook</span>
            <h1>{selectedLeague?.name || title}</h1>
            <p>{selectedLeague ? "Published rules, tiebreak order, and public competition settings for teams entering the field." : description}</p>
            <div className="leaguePageHeroMeta">
              {selectedLeague ? <StatusBadge status={selectedLeague.status} /> : null}
              {selectedLeague?.format ? <span>{String(selectedLeague.format).replace(/_/g, " ")}</span> : null}
            </div>
          </div>
        </div>
      </div>
      {metricsNode}
      {gateNode}
      {message ? <p className="successMessage">{message}</p> : null}
      {error ? <p className="errorMessage">{error}</p> : null}
      {tabsNode}
      <div className="leagueRouteShell leagueRulesShell">
        <aside className="leagueRouteRail">{railNode}</aside>
        <div className="leagueRouteMain leagueRulesStage">{mainNode}</div>
      </div>
    </section>
  );
}

export default LeagueRulesPage;
